package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import org.jetbrains.compose.web.css.px

@Composable
fun toolUseHeading(breakpoint: Breakpoint){
    val sitePalette = ColorMode.current.toSitePalette()
    FieldTitleTextNormalSimple(
        "TOOLS AND TECHNOLOGIES WE USE",
        color = sitePalette.commonSecondaryButtonColor.rgb,
        fontSize = if (breakpoint > Breakpoint.MD) 18.px else 15.px,
        marginTop = 40.px,
        marginBottom = if (breakpoint < Breakpoint.MD) 5.px else 0.px
    )
}